import { Container } from "../HtmlTags/Container/Container";
import { Select } from "../HtmlTags/Select/Select";

type DatePickerSelectProps = {
  value: string;
  onChange: (value: string) => void;
  onOpenChange?: (open: boolean) => void;
  placeholder: string;
  options: { value: string; label: string }[];
  className: string;
};

export const DatePickerSelect = ({
  value,
  onChange,
  onOpenChange,
  placeholder,
  options,
  className,
}: DatePickerSelectProps) => (
  <Container
    className={`date-picker-field-inner-wrap ${className}`}
    data-testid="date-picker-select"
  >
    <Select
      {...(value !== "" ? { value } : {})}
      onChange={onChange}
      onOpenChange={onOpenChange}
      placeholder={placeholder}
      options={options}
    />
  </Container>
);
